import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import { GetInvoicesDto } from '../../../models/dtos/getInvoices.dto';
import getInvoicesRepository from './getInvoices.repository';
import getOverdueInvoicesRepository from './getOverdueInvoices.repository';
import { OverdueInvoice } from '../../../models/response/overdueInvoice';

type InitialState = {
  loading: boolean;
  data?: OverdueInvoice[];
  error?: ErrorDto;
};

const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getOverdueInvoices = createAsyncThunk(
  'getOverdueInvoices',
  async () => {
    return await getOverdueInvoicesRepository().catch((error) => {
      throw error;
    });
  }
);

const getOverdueInvoicesSlice = createSlice({
  name: 'getOverdueInvoices',
  initialState,
  reducers: {
    getOverdueInvoicesReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getOverdueInvoices.pending, (state) => {
      state.loading = true;
      state.data = [];
      state.error = undefined;
    });
    builder.addCase(
      getOverdueInvoices.fulfilled,
      (state, action: PayloadAction<OverdueInvoice[]>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getOverdueInvoices.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default getOverdueInvoicesSlice.reducer;
export const { getOverdueInvoicesReset } = getOverdueInvoicesSlice.actions;
